export function scrollTo(ele: HTMLElement) {
  ele.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
}
